import React from 'react';
import useIntl from '@i18n/useIntl';
import { Text, Heading } from '@amzn/storm-ui';
import {
  SELLING_ACCOUNT_MESSAGE_TRANSLATION_KEY,
  SELLING_ACCOUNT_TITLE_TRANSLATION_KEY,
} from '@features/account-registration/components/SellingAccounts/constants';
import { SellingAccountsTitleWrapper } from './style';

const SellingAccountsTitle = () => {
  const { intl } = useIntl();
  return (
    <SellingAccountsTitleWrapper>
      <Heading renderAs="h4" size="large">
        {intl.getMessage(SELLING_ACCOUNT_TITLE_TRANSLATION_KEY)}
      </Heading>
      <Text size="base">
        {intl.getMessage(SELLING_ACCOUNT_MESSAGE_TRANSLATION_KEY)}
      </Text>
    </SellingAccountsTitleWrapper>
  );
};

export default SellingAccountsTitle;
